import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../generic-components/Button';

interface IUnlinkPlaidAccountConfirmationProps {
  onUnlinkAccount: () => void;
  onClose: () => void;
  isUnlinkingAccountLoading: boolean;
}

const UnlinkPlaidAccountConfirmation = ({
  onUnlinkAccount,
  onClose,
  isUnlinkingAccountLoading,
}: IUnlinkPlaidAccountConfirmationProps) => {
  const { t } = useTranslation();
  return (
    <div className='w-[380px] h-[247px] rounded-[12px] bg-bw00 flex flex-col items-center pt-[34px] pb-[24px] px-[24px]'>
      <div className='font-metricRMedium text-[18px] text-bw08 leading-6 text-center mb-[24px]'>
        {t('UNLINK_PLAID_MODAL.TITLE')}
      </div>
      <div className='font-metricR text-md text-bw07 leading-6 text-center mb-[36px]'>
        {t('UNLINK_PLAID_MODAL.SUBTITLE')}
      </div>
      <div className='flex w-full justify-center'>
        <Button
          onClick={onClose}
          className='w-[157px] h-[54px] rounded bg-bw02 flex items-center justify-center font-metricRMedium text-action03 text-md mr-[16px]'
          id=''
          title={t('UNLINK_PLAID_MODAL.CTA_CANCEL')}
        />
        <Button
          isLoading={isUnlinkingAccountLoading}
          onClick={onUnlinkAccount}
          className='w-[140px] h-[54px] rounded bg-red02 flex items-center justify-center font-metricRMedium text-bw00 text-md'
          id=''
          title={t('UNLINK_PLAID_MODAL.CTA_DELETE')}
        />
      </div>
    </div>
  );
};

export default UnlinkPlaidAccountConfirmation;
